import Html from "@core/libs/html";
import RateLimiter from '@core/libs/rate_limiter';

class Toc {
    constructor(
        private html: Html,
        private rateLimiter: RateLimiter
    ) { }

    init(elementIds: string[]): void {
        if (elementIds.length === 0) {
            return;
        }

        const tocElement = this.html.q('#toc-container');
        const endElement = this.html.q('#article-end');
        const startElement = this.html.q('#article-start');

        const onScroll = this.rateLimiter.throttle(() => {

            let i = 0;
            for (i = elementIds.length - 1; i >= 0; i--) {
                if (elementIds[i] === '#') {
                    break;
                }

                const el = this.html.q(elementIds[i]);
                if (!el) {
                    return;
                }

                if (window.pageYOffset >= el.getBoundingClientRect().top + window.pageYOffset - 110) {
                    break;
                }
            }

            this.html.qAll('.toc-active').forEach((link: HTMLElement) => {
                link.classList.remove('toc-active');
            });
            this.html.q(`.toc[href="${elementIds[i]}"]`)?.classList.add('toc-active')

            if (tocElement && endElement && startElement) {
                tocElement.style.opacity = (startElement.getBoundingClientRect().bottom+500-window.innerHeight > 0 && window.innerWidth >= 1400) ? '0%' : '100%';
            
                const endTop =
                    endElement.getBoundingClientRect().top +
                    window.pageYOffset -
                    window.innerHeight;
            
                if (window.pageYOffset >= endTop) {
                    tocElement.style.opacity = '0%';
                }
            }
            
        }, 100);

        window.addEventListener('scroll', onScroll);
        onScroll();
    }
}

export default Toc;